import { Tutorial } from 'src/replicant/buruburu/tutorial';
import StateObserver from 'src/StateObserver';
import { BasicGameplayTutorial } from './handlers/1-BasicGameplayTutorial';
import { DuoInviteTutorial } from './handlers/10-DuoInviteTutorial';
import { DuoInviteReceivedTutorial } from './handlers/14-DuoInviteReceivedTutorial';
import { ChatWithPetTutorial } from './handlers/2-ChatWithPetTutorial';
import { CareForPetTutorial } from './handlers/3-CareForPetTutorial';
import { PetSickTutorial } from './handlers/4-PetSickTutorial';
import { FriendReferralTutorial } from './handlers/5-FriendReferralTutorial';
import { ProfileTutorial } from './handlers/6-ProfileTutorial';
import { Match3Tutorial } from './handlers/7-Match3Tutorial';
import { VisitFriendTutorial } from './handlers/8-VisitFriendTutorial';
import { AdultTutorial } from './handlers/9-AdultTutorial';
import { TutorialHandler } from './handlers/TutorialHandler';
import PopupMonitor from '../logic/PopupMonitor';

// All supported tutorial events.
export type TutorialEvent =
  | 'gameStarted'
  | 'careMenuOpened'
  | 'conversationStarted'
  | 'conversationFinished'
  | 'friendReferralPopupOpened'
  | 'profilePopupOpened'
  | 'match3Started'
  | 'visitPopupOpened'
  | 'duoInviteSequenceStarted'
  | 'duoInvitationReceived'
  | 'petEvolved';

export class TutorialController {
  /**
   * List of tutorial handlers.
   */
  private handlers: TutorialHandler[] = [
    new BasicGameplayTutorial(),
    new ChatWithPetTutorial(),
    new CareForPetTutorial(),
    new PetSickTutorial(),
    // new FriendReferralTutorial(),
    new ProfileTutorial(),
    new Match3Tutorial(),
    // new VisitFriendTutorial(),
    new AdultTutorial(),
    // new DuoInviteTutorial(),
    // new DuoInviteReceivedTutorial(),
  ];

  /**
   * Handles an event, starting a tutorial if necessary.
   * @param event - The event to handle.
   * @returns - True if a tutorial was started, false otherwise.
   */
  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    // Skip if there is a tutorial popup aleady open, to prevent double popup errors.
    if (PopupMonitor.isOpen('popupTutorialStep')) {
      return false;
    }

    const { user } = StateObserver.getState();
    const { isTutorialStepComplete } = Tutorial.getters(user);

    // Filter out handlers that are already complete.
    const remainingHandlers = [];
    for (let i = 0; i < this.handlers.length; i++) {
      const handler = this.handlers[i];

      if (!isTutorialStepComplete(handler.step)) {
        remainingHandlers.push(handler);
      }
    }
    this.handlers = remainingHandlers;

    // Execute all handlers.
    let executed = false;
    for (const handler of this.handlers) {
      executed ||= await handler.handleEvent(event);
    }

    return executed;
  }
}

let tutorialController: TutorialController;
export function getTutorialController() {
  if (!tutorialController) {
    tutorialController = new TutorialController();
  }

  return tutorialController;
}
